import React from 'react';
import { COLORS } from '../utils/constants.js';

export default function Notifications({ notifications }) {
  return (
    <div
      style={{
        position: 'fixed',
        top: 16,
        right: 16,
        zIndex: 1000,
        display: 'flex',
        flexDirection: 'column',
        gap: 8,
      }}
    >
      {notifications.map((n) => (
        <div
          key={n.id}
          style={{
            padding: '10px 16px',
            borderRadius: 8,
            fontSize: 13,
            fontWeight: 500,
            background:
              n.type === 'success'
                ? COLORS.greenDim
                : n.type === 'error'
                ? '#7f1d1d'
                : COLORS.surfaceAlt,
            border: `1px solid ${
              n.type === 'success'
                ? COLORS.green
                : n.type === 'error'
                ? COLORS.red
                : COLORS.border
            }`,
            color: COLORS.text,
            animation: 'slideIn 0.3s ease',
            boxShadow: '0 4px 12px rgba(0,0,0,0.3)',
          }}
        >
          {n.msg}
        </div>
      ))}
    </div>
  );
}
